import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';


@Component({
  selector: 'app-monitors',
  templateUrl: './monitors.component.html',
  styleUrls: ['./monitors.component.scss']
})
export class MonitorsComponent implements OnInit {

  monitors : any;

  view : any;
  sort = 'name';
  formGroup  = new FormGroup ({
    search: new FormControl('',[]),
  });

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  constructor(private router: Router, private route: ActivatedRoute, public okService:OkAloneService) { }

  ngOnInit(): void {

    this.pagination.page = 1;
    this.getMonitors();

  }

  getMonitors(){

    let filter = {
      sort: this.sort,
      search: this.formGroup.value.search,
      page: this.pagination.page,
    }

    //console.log("filter",filter);

    this.okService.get("monitors",filter)
    .subscribe((data) => {

      this.monitors = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;

      //console.log("this.monitors",data);

    });

  }

  changePage(){
    //console.log(this.okService.pagination.page);
    this.getMonitors();
  }

  updateFilter(){
    if (this.formGroup.valid) {
        //console.log(this.formGroup.value);
        this.getMonitors();
    }
  }

  cancelSearch(){
    this.formGroup.setValue({
      search: ''
    });
    this.updateFilter();

  }

  // Get the monitor token and login as that monitor
  dashboardLogin(monitor:any){


    this.okService.get("monitors/"+monitor.id,{expand:"token"})
    .subscribe((data:any) => {

      //console.log(data.body);

      if(data.body['token']){
        let url = this.okService.dashboardUrl+"?ul="+data.body['token'];
        window.open(url);

      }

    });

  }

  export(){
    this.okService.download("monitors/export");
  }
}
